
function getOrdinalNum(n) {
  return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
}

function getMonth(n) {
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

	return monthNames[n];
}

export default function dailyMarket() {

    if (!document.querySelector('.daily-market')) {
      return;
    }

		var xhr = new XMLHttpRequest();
		xhr.open('GET', '/api/getblog');

		xhr.onload = function() {
		    if (xhr.status === 200) {
		        //console.log(xhr.responseText);

						var json = JSON.parse(xhr.responseText);
						//console.log(json);

						if (json.length) {
							var container = document.querySelector('.daily-market__hidden');
							container.classList.remove("daily-market__hidden");
						}

						for (var i = 0; i < json.length; i++) {
							var curr = json[i];
							//console.log('title', curr.title.rendered);
							//console.log('date', curr.date);
							//console.log('content', curr.excerpt.rendered);
							//console.log('link', curr.link);

							var elem = document.querySelector('.daily-market__posts-' + (i + 1));
							elem.href = curr.link;
							elem.target = "_blank";

							var title = elem.querySelector('.daily-market__posts-title');
							title.innerHTML = curr.title.rendered;

							var d = elem.querySelector('.daily-market__posts-date');

							var r = /\d+/g;
							var time = curr.date.match(r);
							//console.log(time);

							var dateObj = new Date();
							dateObj.setTime(time[0]);
							//console.log ( getOrdinalNum(dateObj.getDate()) );

							d.innerHTML = getMonth(dateObj.getMonth()) + " " + getOrdinalNum(dateObj.getDate()) + ", " + dateObj.getFullYear();

							var body = elem.querySelector('.daily-market__posts-content-body');

							var div = document.createElement("div");
							div.innerHTML = curr.excerpt.rendered;
							var bodyText = div.textContent || div.innerText || "";
							//console.log('text', bodyText);

							var trimmedString = bodyText.length > 180 ?
                    bodyText.substring(0, 180 - 3) + "... " :
                    bodyText;

							body.innerHTML = trimmedString.replace(/\s\s+/g, ' ');
						}
		    }
		    else {
		        console.log('Request failed with status: ' + xhr.status);
		    }
		};
		xhr.send();
}
